import { DBAdapterDefaultMixin } from '@powersync/common';
/**
 * A connection pool implementation delegating to another pool opened asynchronnously.
 */
class AsyncConnectionPool {
    name;
    inner;
    resolvedClient;
    pendingListeners = new Set();
    constructor(inner, name) {
        this.name = name;
        this.inner = inner.then((client) => {
            for (const pending of this.pendingListeners) {
                pending.closeAfterRegisteredOnResolvedPool = client.registerListener(pending.listener);
            }
            this.pendingListeners.clear();
            this.resolvedClient = client;
            return client;
        });
    }
    async init() {
        await this.inner;
    }
    async close() {
        const inner = await this.inner;
        return await inner.close();
    }
    async readLock(fn, options) {
        const inner = await this.inner;
        return await inner.readLock(fn, options);
    }
    async writeLock(fn, options) {
        const inner = await this.inner;
        return await inner.writeLock(fn, options);
    }
    async refreshSchema() {
        await (await this.inner).refreshSchema();
    }
    registerListener(listener) {
        if (this.resolvedClient) {
            return this.resolvedClient.registerListener(listener);
        }
        else {
            const pending = { listener };
            this.pendingListeners.add(pending);
            return () => {
                if (pending.closeAfterRegisteredOnResolvedPool) {
                    return pending.closeAfterRegisteredOnResolvedPool();
                }
                else {
                    // Has not been registered yet, we can just remove the pending listener.
                    this.pendingListeners.delete(pending);
                }
            };
        }
    }
}
export class AsyncDbAdapter extends DBAdapterDefaultMixin(AsyncConnectionPool) {
    async shareConnection() {
        const inner = await this.inner;
        return inner.shareConnection();
    }
    getConfiguration() {
        if (this.resolvedClient) {
            return this.resolvedClient.getConfiguration();
        }
        throw new Error('AsyncDbAdapter.getConfiguration() can only be called after initializing it.');
    }
}
